import React from 'react';
import { BookOpen, FileText, Palette } from 'lucide-react';

const iconMap = {
    BookOpen,
    FileText,
    Palette,
};

const SectionIcon = ({ name }) => {
    const Icon = iconMap[name] || FileText;

    return (
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[8px] bg-[#f5f3f0] text-[#38433A]">
            <Icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
        </div>
    );
};

export default SectionIcon;
